import { createAction } from 'redux-actions';

// action types
export const USER_PERSONA_DISCOVERED = 'USER_PERSONA_DISCOVERED';

// actions
export const userPersonaDiscovered = createAction(USER_PERSONA_DISCOVERED);
